import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";
import api, { fmtIDR } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Panel } from "./admin/ui";

export default function BuyerBalance() {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/balance").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <Panel testId="buyer-balance-panel">
      <div className="flex items-center gap-3 mb-2">
        <Wallet className="text-[#D4AF37]" size={22} />
        <h2 className="text-xl font-bold text-[#F5F3ED]" style={{ fontFamily: "'Playfair Display', serif" }}>{t("balance.title")}</h2>
      </div>
      <div data-testid="buyer-balance-amount" className="text-3xl font-bold text-[#D4AF37] mb-1">{fmtIDR(data.balance_idr)}</div>
      <p className="text-xs text-[#A8A8AD] mb-4">{t("balance.desc")}</p>
      {data.transactions.length > 0 && (
        <>
          <div className="text-xs uppercase tracking-widest text-[#A8A8AD] mb-2">{t("balance.history")}</div>
          {data.transactions.map((x) => (
            <div key={x.id} data-testid={`balance-tx-${x.id}`} className="flex justify-between gap-4 py-2 border-b border-[#35353B] text-sm">
              <div>
                <div className="text-[#F5F3ED]">{t(`balance.${x.type}`)}{x.order_id && <Link to={`/orders/${x.order_id}`} className="text-[#D4AF37] hover:underline ml-2 text-xs">{t("order.detail")}</Link>}</div>
                <div className="text-xs text-[#A8A8AD]">{new Date(x.created_at).toLocaleString()}</div>
              </div>
              <div className={x.amount_idr > 0 ? "text-[#35C78A] font-bold" : "text-[#F06464] font-bold"}>{x.amount_idr > 0 ? "+" : ""}{fmtIDR(x.amount_idr)}</div>
            </div>
          ))}
        </>
      )}
    </Panel>
  );
}
